module.exports = __webpack_public_path__ + "img/xtsz_icon.5230d128.png";